module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_shrines_temples-a5c9dddd46362f1670cc088c77dee762.jpg";